/* IVY OF CAMBRIDGE — Theme JS */

(function () {
  'use strict';

  // --- Cart state ---
  const cartBtn   = document.getElementById('cart-btn');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose  = document.getElementById('cart-close');

  function openCart() {
    cartDrawer?.classList.add('is-open');
    cartOverlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    cartDrawer?.setAttribute('aria-hidden', 'false');
  }

  function closeCart() {
    cartDrawer?.classList.remove('is-open');
    cartOverlay?.classList.remove('is-open');
    document.body.style.overflow = '';
    cartDrawer?.setAttribute('aria-hidden', 'true');
  }

  cartBtn?.addEventListener('click', openCart);
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  // --- Mobile nav ---
  const mobileMenuBtn = document.getElementById('mobile-menu-btn');
  const mobileNav     = document.getElementById('mobile-nav');
  const mobileClose   = document.getElementById('mobile-nav-close');

  mobileMenuBtn?.addEventListener('click', () => {
    mobileNav?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });
  mobileClose?.addEventListener('click', () => {
    mobileNav?.classList.remove('is-open');
    document.body.style.overflow = '';
  });

  // --- Search overlay ---
  const searchBtn   = document.getElementById('search-btn');
  const searchOverlay = document.getElementById('search-overlay');
  const searchClose  = document.getElementById('search-close');
  const searchInput  = document.getElementById('search-input');

  searchBtn?.addEventListener('click', () => {
    searchOverlay?.classList.add('is-open');
    setTimeout(() => searchInput?.focus(), 100);
  });
  searchClose?.addEventListener('click', () => searchOverlay?.classList.remove('is-open'));
  searchOverlay?.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') searchOverlay.classList.remove('is-open');
  });

  // --- AJAX cart helpers ---
  async function cartFetch(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error('Cart request failed');
    return res.json();
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
      el.dataset.count = count;
    });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function showError(msg) {
    let toast = document.getElementById('ivy-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'ivy-toast';
      toast.className = 'ivy-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('is-visible');
    setTimeout(() => toast.classList.remove('is-visible'), 4000);
  }

  function renderCartDrawer(cart) {
    const body = document.getElementById('cart-drawer-body');
    const footer = document.getElementById('cart-drawer-footer');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-empty">
          <i class="ti ti-shopping-bag"></i>
          <p>Your bag is empty</p>
          <a href="/collections/all" class="btn-brass">Explore the collection</a>
        </div>`;
      if (footer) footer.hidden = true;
    } else {
      body.innerHTML = cart.items.map(item => `
        <div class="cart-item" data-key="${escapeHtml(item.key)}">
          <a class="cart-item__image-wrap" href="${escapeHtml(item.url)}">
            ${item.image
              ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" width="60" height="80" loading="lazy">`
              : `<div class="cart-item__image-placeholder"><i class="ti ti-home"></i></div>`}
          </a>
          <div class="cart-item__info">
            <a class="cart-item__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
            ${item.variant_title && item.variant_title !== 'Default Title'
              ? `<p class="cart-item__variant">${escapeHtml(item.variant_title)}</p>`
              : ''}
            <div class="cart-item__meta">
              <div class="cart-item__qty-wrap">
                <button class="qty-btn" data-action="decrease" data-key="${escapeHtml(item.key)}" aria-label="Decrease">−</button>
                <span class="cart-item__qty">${item.quantity}</span>
                <button class="qty-btn" data-action="increase" data-key="${escapeHtml(item.key)}" aria-label="Increase">+</button>
              </div>
              <span class="cart-item__price">${formatMoney(item.line_price)}</span>
            </div>
          </div>
          <button class="cart-item__remove" data-action="remove" data-key="${escapeHtml(item.key)}" aria-label="Remove">
            <i class="ti ti-x"></i>
          </button>
        </div>`).join('');

      if (footer) {
        footer.hidden = false;
        const subtotalEl = footer.querySelector('.cart-subtotal__price');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      }
    }

    document.querySelectorAll('.cart-drawer__count').forEach(el => {
      el.textContent = `(${cart.item_count})`;
    });
  }

  async function refreshCartDrawerBody() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
    } catch (e) { /* silent — drawer already open, stale state is acceptable */ }
  }

  // --- Add to cart form ---
  const addToCartForms = document.querySelectorAll('[data-add-to-cart-form]');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart-btn]');
      const variantId = form.querySelector('[name="id"]')?.value;
      const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1');
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'Adding…';

      try {
        const data = await cartFetch('/cart/add.js', { id: variantId, quantity: qty });
        const cart = await fetch('/cart.js').then(r => r.json());
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
        btn.textContent = 'Added!';
        openCart();
        setTimeout(() => {
          btn.disabled = false;
          btn.innerHTML = 'Add to bag <i class="ti ti-shopping-bag"></i>';
        }, 2000);
      } catch (err) {
        btn.disabled = false;
        btn.innerHTML = 'Add to bag <i class="ti ti-shopping-bag"></i>';
        showError('Could not add to bag — please try again.');
      }
    });
  });

  // --- Cart quantity / remove ---
  async function refreshCartDrawerBody() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      // Update subtotal text
      document.querySelectorAll('.cart-subtotal__price').forEach(el => {
        el.textContent = formatMoney(cart.total_price);
      });
      document.querySelectorAll('.cart-drawer__count').forEach(el => {
        el.textContent = `(${cart.item_count})`;
      });
      updateCartCount(cart.item_count);
    } catch (e) { /* silent */ }
  }

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  document.addEventListener('click', async (e) => {
    const qtyBtn = e.target.closest('.qty-btn');
    const removeBtn = e.target.closest('[data-action="remove"]');

    if (qtyBtn) {
      if (qtyBtn.disabled) return;
      const key    = qtyBtn.dataset.key;
      const action = qtyBtn.dataset.action;
      const qtyEl  = qtyBtn.closest('.cart-item__meta')?.querySelector('.cart-item__qty')
                     || qtyBtn.closest('.cart-item')?.querySelector('.cart-item__qty');
      let qty = parseInt(qtyEl?.textContent || '1');
      qty = action === 'increase' ? qty + 1 : Math.max(0, qty - 1);

      qtyBtn.disabled = true;
      try {
        const cart = await cartFetch('/cart/change.js', { id: key, quantity: qty });
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
      } catch (e) {
        showError('Could not update bag — please try again.');
      } finally {
        qtyBtn.disabled = false;
      }
    }

    if (removeBtn) {
      const key = removeBtn.dataset.key;
      try {
        const cart = await cartFetch('/cart/change.js', { id: key, quantity: 0 });
        updateCartCount(cart.item_count);
        if (cart.item_count === 0 && document.querySelector('.cart-table')) {
          location.reload();
        } else {
          removeBtn.closest('.cart-item, tr')?.remove();
          const cartPageTitle = document.querySelector('.cart-page__title');
          if (cartPageTitle) cartPageTitle.textContent = `Your bag (${cart.item_count})`;
          const cartTotal = document.querySelector('.cart-total span:last-child');
          if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);
        }
        renderCartDrawer(cart);
      } catch (e) {
        showError('Could not remove item — please try again.');
      }
    }
  });

  // --- Product page: carousel gallery ---
  let carouselGoTo = null;

  const carouselTrack = document.getElementById('carousel-track');
  if (carouselTrack) {
    const slides = Array.from(carouselTrack.querySelectorAll('.product-carousel__slide'));
    const thumbs = Array.from(document.querySelectorAll('.product-thumb[data-slide]'));
    const mainSlideCount = slides.filter(s => !s.classList.contains('product-carousel__slide--variant')).length;
    let current = 0;
    let lastMainIdx = 0;

    function goToSlide(index) {
      current = ((index % slides.length) + slides.length) % slides.length;
      carouselTrack.style.transform = `translateX(-${current * 100}%)`;
      if (current < mainSlideCount) {
        lastMainIdx = current;
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === current));
      } else {
        thumbs.forEach(t => t.classList.remove('is-active'));
      }
    }

    function goToMainSlide(delta) {
      const next = ((lastMainIdx + delta) % mainSlideCount + mainSlideCount) % mainSlideCount;
      goToSlide(next);
    }

    carouselGoTo = goToSlide;

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => goToSlide(parseInt(thumb.dataset.slide, 10)));
    });

    document.getElementById('carousel-prev')?.addEventListener('click', () => goToMainSlide(-1));
    document.getElementById('carousel-next')?.addEventListener('click', () => goToMainSlide(+1));

    let touchStartX = 0;
    carouselTrack.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    carouselTrack.addEventListener('touchend', e => {
      const delta = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(delta) > 40) goToMainSlide(delta > 0 ? 1 : -1);
    });
  }

  // --- Variant selector ---
  document.querySelectorAll('[data-add-to-cart-form]').forEach(form => {
    const variantDataEl = form.querySelector('[data-product-variants]');
    if (!variantDataEl) return;

    const { options, variants } = JSON.parse(variantDataEl.textContent);
    const hiddenId = form.querySelector('[name="id"]');
    const addToCartBtn = form.querySelector('[data-add-to-cart-btn]');

    function selectedOptions() {
      const sel = {};
      form.querySelectorAll('.variant-options').forEach(group => {
        const active = group.querySelector('.variant-btn.is-active');
        if (active) sel[active.dataset.option] = active.dataset.value;
      });
      return sel;
    }

    function findVariant(sel) {
      return variants.find(v => options.every((name, i) => v.options[i] === sel[name]));
    }

    function updateGallery(variant) {
      if (!variant || !carouselGoTo) return;
      const fii = variant.fii;
      if (!fii) return;
      const fiiStr = String(fii);
      const slides = Array.from(document.querySelectorAll('.product-carousel__slide'));
      const mainIdx = slides.findIndex(s => s.dataset.imageId === fiiStr);
      const idx = mainIdx !== -1 ? mainIdx : slides.findIndex(s => s.dataset.variantImageId === fiiStr);
      if (idx !== -1) carouselGoTo(idx);
    }

    function updateButton(variant) {
      const notifyWrap = document.getElementById('notify-wrap');
      const avail = variant?.available ?? false;

      if (notifyWrap) {
        notifyWrap.style.display = avail ? 'none' : '';
        if (!avail && variant) {
          const bodyInput = notifyWrap.querySelector('[data-notify-body]');
          if (bodyInput) {
            const title = document.querySelector('[data-product-title]')?.textContent?.trim() || '';
            bodyInput.value = `Please notify me when back in stock: ${title} – ${variant.title} (variant ${variant.id})`;
          }
        }
      }

      if (!addToCartBtn) return;
      addToCartBtn.disabled = !avail;
      addToCartBtn.innerHTML = avail
        ? 'Add to bag <i class="ti ti-shopping-bag"></i>'
        : 'Out of stock';
    }

    function updatePrice(variant) {
      const el = document.getElementById('product-price');
      if (!el || !variant) return;
      if (variant.compare_at_price > variant.price) {
        const pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        el.innerHTML = `
          <s class="price-was">${formatMoney(variant.compare_at_price)}</s>
          <span class="price-now sale-price">${formatMoney(variant.price)}</span>
          <span class="price-save">Save ${pct}%</span>`;
      } else {
        el.innerHTML = `<span class="price-now">${formatMoney(variant.price)}</span>`;
      }
    }

    function updateOptionAvailability() {
      const sel = selectedOptions();
      form.querySelectorAll('.variant-options').forEach(group => {
        const optionName = group.querySelector('.variant-btn')?.dataset.option;
        if (!optionName) return;
        group.querySelectorAll('.variant-btn').forEach(btn => {
          const hypothetical = { ...sel, [optionName]: btn.dataset.value };
          const available = variants.some(v =>
            options.every((name, i) => v.options[i] === hypothetical[name]) && v.available
          );
          btn.classList.toggle('is-unavailable', !available);
          if (available) btn.removeAttribute('aria-disabled');
          else btn.setAttribute('aria-disabled', 'true');
        });
      });
    }

    form.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        btn.closest('.variant-options')
          ?.querySelectorAll('.variant-btn')
          .forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const variant = findVariant(selectedOptions());
        if (variant && hiddenId) hiddenId.value = variant.id;
        updatePrice(variant);
        updateButton(variant);
        updateGallery(variant);
        updateOptionAvailability();
      });
    });

    updateOptionAvailability();
  });

  // --- Product page qty steppers ---
  document.querySelectorAll('.qty-stepper').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.product-qty__controls')?.querySelector('[name="quantity"]');
      if (!input) return;
      const val = parseInt(input.value) || 1;
      input.value = btn.dataset.action === 'increase' ? val + 1 : Math.max(1, val - 1);
    });
  });

  // --- Collection sort ---
  const sortSelect = document.getElementById('sort-by');
  sortSelect?.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location.href = url.toString();
  });

  // --- Product recommendations ---
  const recsContainer = document.getElementById('product-recommendations');
  if (recsContainer) {
    const productId = recsContainer.dataset.productId;
    fetch(`/recommendations/products.json?product_id=${productId}&limit=8`)
      .then(r => r.json())
      .then(({ products }) => {
        if (!products || products.length === 0) return;
        const grid = document.getElementById('product-recs-grid');
        grid.innerHTML = products.map(p => {
          const price = formatMoney(p.price_min);
          const comparePrice = p.compare_at_price_min > p.price_min
            ? formatMoney(p.compare_at_price_min) : null;
          const imgSrc = p.featured_image
            ? p.featured_image.replace(/(\.\w+)(\?|$)/, '_600x600$1$2')
            : null;
          const imgHtml = imgSrc
            ? `<img src="${escapeHtml(imgSrc)}" alt="${escapeHtml(p.title)}" loading="lazy">`
            : `<div class="product-recs__placeholder"><i class="ti ti-home"></i></div>`;
          return `
            <a class="product-recs__card" href="/products/${escapeHtml(p.handle)}">
              <div class="product-recs__image-wrap">${imgHtml}</div>
              <p class="product-recs__name">${escapeHtml(p.title)}</p>
              <p class="product-recs__price">${comparePrice ? `<s>${comparePrice}</s> ` : ''}${price}</p>
            </a>`;
        }).join('');
        recsContainer.style.display = '';

        const prevBtn = recsContainer.querySelector('.product-recs__nav--prev');
        const nextBtn = recsContainer.querySelector('.product-recs__nav--next');
        const updateNavState = () => {
          if (prevBtn) prevBtn.disabled = grid.scrollLeft <= 0;
          if (nextBtn) nextBtn.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 1;
        };
        const scrollBy = () => {
          const card = grid.querySelector('.product-recs__card');
          return card ? card.offsetWidth + 16 : 260;
        };
        prevBtn?.addEventListener('click', () => { grid.scrollBy({ left: -scrollBy(), behavior: 'smooth' }); });
        nextBtn?.addEventListener('click', () => { grid.scrollBy({ left: scrollBy(), behavior: 'smooth' }); });
        grid.addEventListener('scroll', updateNavState, { passive: true });
        updateNavState();
      })
      .catch(() => {});
  }

  // --- Wishlist ---
  const WISHLIST_KEY = 'ivy_wishlist';

  function wishlistGet() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch { return []; }
  }
  function wishlistSet(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }
  function wishlistToggle(handle) {
    const list = wishlistGet();
    const idx = list.indexOf(handle);
    if (idx === -1) list.push(handle); else list.splice(idx, 1);
    wishlistSet(list);
    syncWishlistUI();
  }

  const wishlistGrid     = document.getElementById('wishlist-grid');
  const wishlistEmpty    = document.getElementById('wishlist-empty');
  const wishlistCountTxt = document.getElementById('wishlist-count-text');

  function syncWishlistUI() {
    const list = wishlistGet();
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const saved = list.includes(btn.dataset.wishlistToggle);
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', String(saved));
      const icon = btn.querySelector('i');
      if (icon) icon.className = saved ? 'ti ti-heart-filled' : 'ti ti-heart';
      // On the wishlist page, remove a card immediately when unsaved
      if (!saved && wishlistGrid && btn.closest('#wishlist-grid')) {
        btn.closest('.product-card')?.remove();
        const remaining = wishlistGrid.querySelectorAll('.product-card').length;
        if (wishlistCountTxt) wishlistCountTxt.textContent = `${remaining} item${remaining !== 1 ? 's' : ''}`;
        if (remaining === 0) {
          wishlistGrid.hidden = true;
          if (wishlistEmpty) wishlistEmpty.hidden = false;
        }
      }
    });
  }

  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    wishlistToggle(btn.dataset.wishlistToggle);
  });

  syncWishlistUI();

  // Render wishlist page grid
  if (wishlistGrid) {
    const handles = wishlistGet();
    if (handles.length === 0) {
      if (wishlistEmpty) wishlistEmpty.hidden = false;
    } else {
      wishlistGrid.hidden = false;
      Promise.allSettled(
        handles.map(h => fetch(`/products/${encodeURIComponent(h)}.js`).then(r => r.ok ? r.json() : null))
      ).then(results => {
        const products = results.map(r => r.value).filter(Boolean);
        if (wishlistCountTxt) wishlistCountTxt.textContent = `${products.length} item${products.length !== 1 ? 's' : ''}`;
        if (products.length === 0) {
          wishlistGrid.hidden = true;
          if (wishlistEmpty) wishlistEmpty.hidden = false;
          return;
        }
        wishlistGrid.innerHTML = products.map(p => {
          const price = formatMoney(p.price);
          const comparePrice = p.compare_at_price > p.price ? formatMoney(p.compare_at_price) : null;
          const imgSrc = p.featured_image
            ? p.featured_image.replace(/(\.\w+)(\?|$)/, '_600x600$1$2')
            : null;
          const imgHtml = imgSrc
            ? `<img src="${escapeHtml(imgSrc)}" alt="${escapeHtml(p.title)}" loading="lazy">`
            : `<div class="product-card__placeholder"><i class="ti ti-home"></i></div>`;
          return `
            <div class="product-card">
              <a href="/products/${escapeHtml(p.handle)}" class="product-card__image-wrap">${imgHtml}</a>
              <button class="product-card__wishlist is-saved"
                      data-wishlist-toggle="${escapeHtml(p.handle)}"
                      aria-label="Remove from wishlist"
                      aria-pressed="true">
                <i class="ti ti-heart-filled"></i>
              </button>
              <a href="/products/${escapeHtml(p.handle)}">
                <p class="product-card__name">${escapeHtml(p.title)}</p>
              </a>
              <p class="product-card__vendor"></p>
              <p class="product-card__price">${comparePrice ? `<s>${comparePrice}</s> ` : ''}<strong>${price}</strong></p>
            </div>`;
        }).join('');
      });
    }
  }

})();
